module.exports = __webpack_public_path__ + "img/main-gallery5.54684f06.webp";